import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http, formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const bootstrap = useCallback(async () => {
    const token = localStorage.getItem("tk_token");
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await http.get("/auth/me");
      setUser(data);
      localStorage.setItem("tk_user", JSON.stringify(data));
    } catch (e) {
      localStorage.removeItem("tk_token");
      localStorage.removeItem("tk_user");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { bootstrap(); }, [bootstrap]);

  const login = async (username, password) => {
    try {
      const { data } = await http.post("/auth/login", { username, password });
      localStorage.setItem("tk_token", data.access_token);
      localStorage.setItem("tk_user", JSON.stringify(data.user));
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e?.response?.data?.detail) || "Giriş hatası" };
    }
  };

  const logout = () => {
    localStorage.removeItem("tk_token");
    localStorage.removeItem("tk_user");
    sessionStorage.removeItem("home_redirected");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, token: localStorage.getItem("tk_token") }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
